import React, { useEffect } from 'react';
import './index.scss';
import CommonSearchBar from '../common/Search/index';
import Helmet from 'react-helmet';
import {
  DRUG_CLASS_DESC,
  DRUG_CLASS_TITLE,
  DRUG_CLASS_TEXT_BELOW_LINKS,
  DRUG_CLASS_TEXT_BELOW_SEARCH,
  DRUG_CLASS_CANONICAL
} from '../../constants/defaults';
import _ from 'lodash';
import Breadcrumb from '../DrugDetails/Breadcrumb';
import { withTranslation } from 'react-i18next';
import SkipTo from '../common/Tag/SkipTo';
const alphabets = [...Array(26).keys()].map(i => String.fromCharCode(i + 65));

const DrugClasses = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext !== 'undefined' && props.staticContext.data;

  useEffect(() => {
    if (window.location.hash) {
      const sectionId = window.location.hash.substr(1);
      if (sectionId) {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView();
      }
    }
  }, []);

  const handleScroll = elementId => {
    if (typeof window !== 'undefined') {
      window.history.pushState(
        {},
        `drug-classes${elementId}`,
        `${window.location.pathname}#${elementId}`
      );
    }
    document
      .getElementById(elementId)
      .scrollIntoView({ block: 'start', behavior: 'smooth' });

    _.setFocusWithoutReload(`#${elementId}`, 'a');
  };

  const renderSubClassList = subclasses => {
    return (
      !_.isEmpty(subclasses) && (
        <ul>
          {subclasses.map((subClasses, index) => {
            return (
              <li key={index}>
                <a href={`/drug-classes/${subClasses.slug}`}>
                  {subClasses.name}
                </a>
                {renderSubClassList(subClasses.subclasses)}
              </li>
            );
          })}
        </ul>
      )
    );
  };

  const renderAllDrugClasses = allDrugClasses => {
    return (
      !_.isEmpty(allDrugClasses) &&
      allDrugClasses.map((item, index) => {
        return (
          !_.isEmpty(item.classes) && (
            <div
              id={item.letter.toUpperCase()}
              className="alphabetContent"
              key={index}
            >
              <h3 className="alphabetLetter">{item.letter.toUpperCase()}</h3>
              <ul className="drugdName">
                {!_.isEmpty(item.classes) &&
                  item.classes.map((element, i) => {
                    return (
                      <li id={element.slug} key={i}>
                        <a href={`/drug-classes/${element.slug}`}>
                          {element.name}
                        </a>
                        {renderSubClassList(element.subclasses)}
                      </li>
                    );
                  })}
              </ul>
            </div>
          )
        );
      })
    );
  };

  const executeScroll = (e, elementId) => {
    e.preventDefault();
    document
      .getElementById(elementId)
      .scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  return (
    <main>
      <div
        id="mainContentWrapperPublic"
        className="drugclassMainContainer mobileSpacing"
      >
        <Helmet>
          <title>{DRUG_CLASS_TITLE}</title>
          <meta name="description" content={DRUG_CLASS_DESC} />
          <link rel="canonical" href={DRUG_CLASS_CANONICAL} />
        </Helmet>
        <div className="drugClassLanding">
          <div className="topShadow"></div>
          <div className="drugClassLandingSearch">
            <div className="searchBreadcrumb mobile-only">
              <Breadcrumb>
                <span>
                  <a href="/">{`Home`}</a>
                </span>
                <span>{`Drug classes`}</span>
              </Breadcrumb>
            </div>
            <SkipTo>
              <h1 className="textCenter">Browse medications by drug class</h1>
            </SkipTo>
            <div className="masthead--search ">
              <CommonSearchBar
                classes="search-container"
                type={'drug'}
                inputPlaceHolder={
                  'Search by drug class (Muscle relaxants, penicillins, etc.)'
                }
              />
            </div>
            <div className="searchBreadcrumb desktop-only">
              <Breadcrumb>
                <span>
                  <a href="/">{`Home`}</a>
                </span>
                <span>{`Drug classes`}</span>
              </Breadcrumb>
            </div>
          </div>
          <div className="drugClassLandingContent">
            <p>{DRUG_CLASS_TEXT_BELOW_SEARCH}</p>
            <section className="top-drugs">
              <article>
                <h2>Common drug classes</h2>
                <ul>
                  {data.commonDrugClasses.map((item, id) => {
                    return (
                      <li key={id}>
                        <a href={`/drug-classes/${item.slug}`}>
                          <div className="imgColumn">{item.name}</div>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </article>
            </section>
            <div className="drugClassLletter">
              <h2>Browse drug classes by letter:</h2>
              <ul className="alphabet">
                {alphabets.map((alphabet, index) =>
                  !data.emptyTerms.includes(alphabet) ? (
                    <li key={index}>
                      <a
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            handleScroll(alphabet);
                          }
                        }}
                        href={`#${alphabet}`}
                        key={alphabet}
                        onClick={e => executeScroll(e, alphabet)}
                      >
                        {alphabet}
                      </a>
                    </li>
                  ) : (
                    <li key={index}>
                      <span key={alphabet}>{alphabet}</span>
                    </li>
                  )
                )}
              </ul>
              <p>{DRUG_CLASS_TEXT_BELOW_LINKS}</p>
              {renderAllDrugClasses(data.allDrugClasses)}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default withTranslation()(DrugClasses);
